import { xtwhUrls } from '@shared/urls/xtwhUrls';
import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { SettingsService } from '@delon/theme';

@Component({
  selector: 'layout-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent implements OnInit {
  srcUrl: string;

  constructor(public settings: SettingsService) {}
  ngOnInit(): void {
    this.srcUrl = xtwhUrls.files.downloadFile_icon + '?fileName=' + this.settings.user.avatar;
  }
}
